import BaseCadastro from "components/BaseCadastro";
import MapaPercursoVeiculoViagem from "components/maps/MapaPercursoVeiculoViagem";
import VeiculoViagem from 'model/gestao/frotas/VeiculoViagem';
import { useState } from "react";
import "react-hook-form";
import VeiculoViagemService from 'service/gestao/frotas/VeiculoViagemService';
import { converterDataHora } from "utils/convert";
import "./VeiculoViagemMap.scss";
import { Button } from "primereact/button";
import { useToastContext } from "components/alert/ToastContext";
import ModalVeiculoViagemFinalizar from "components/modal/frotas/ModalVeiculoViagemFinalizar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const veiculoViagemService = new VeiculoViagemService();

export default function VeiculoViagemConsultar() {

    const [veiculoViagem, setVeiculoViagem] = useState<VeiculoViagem>(new VeiculoViagem());
    const { msgSucesso, msgErro } = useToastContext();
    const [modalVeiculoViagemFinalizar, setModalVeiculoViagemFinalizar] = useState(false);

    const finalizarViagem = () => {
        setModalVeiculoViagemFinalizar(true);
    }

    const botoesExtra = () => {
        if (veiculoViagem.status === "EM_ANDAMENTO") {
            return <Button style={{ marginLeft: 8 }} label="Finalizar viagem" onClick={finalizarViagem}></Button>
        }
        return null;
    }

    return (

        <BaseCadastro model={veiculoViagem} service={veiculoViagemService} setModel={(value: VeiculoViagem) => setVeiculoViagem(value)}
            novoCadastro validar={() => true} showGravarButton={false} botoesExtra={botoesExtra()} urlService="/veiculoViagem" pathCadastro="/veiculoViagem" tituloPagina={""}>
            <ModalVeiculoViagemFinalizar
                visible={modalVeiculoViagemFinalizar}
                onHide={() => setModalVeiculoViagemFinalizar(false)}
                veiculoViagem={veiculoViagem}
                onConfirm={() => {
                    setModalVeiculoViagemFinalizar(false);
                    veiculoViagemService.consultar(veiculoViagem.id)
                        .then((response) => {
                            setVeiculoViagem(response);
                        })
                        .catch((e) => {
                            msgErro("Erro", e.data?.message || "Ocorreu um erro ao buscar os dados da viagem.");
                        });
                }} />

            <label style={styles.titulo}>Viagem</label>

            <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 20 }}>
                <div style={styles.itemCabecalho}>
                    <label style={styles.labelCabecalho}>Motorista:</label>
                    <span style={styles.fieldCabecalho}>{veiculoViagem.motorista?.nome || ""}</span>
                </div>

                <div style={styles.itemCabecalho}>
                    <label style={styles.labelCabecalho}>Veículo: </label>
                    <span style={styles.fieldCabecalho}>{veiculoViagem?.veiculo ? veiculoViagem.veiculo.placa + " - " + veiculoViagem.veiculo.modelo : ""}</span>
                </div>

                <div style={styles.itemCabecalho}>
                    <label style={styles.labelCabecalho}>Distância percorrida: </label>
                    <span style={styles.fieldCabecalho}>{veiculoViagem?.distanciaPercorrida ? (veiculoViagem.distanciaPercorrida / 1000).toFixed(1).replace(".", ",") + " km" : ""}</span>
                </div>

                <div style={styles.itemCabecalho}>
                    <label style={styles.labelCabecalho}>Período: </label>
                    <span style={styles.fieldCabecalho}>{converterDataHora(veiculoViagem.inicioViagem)}</span>
                    {veiculoViagem.fimViagem ? <span style={styles.labelCabecalho}> até </span> : <span style={styles.labelCabecalho}> (Em andamento) </span>}
                    {veiculoViagem.fimViagem ? <span style={styles.fieldCabecalho}>{converterDataHora(veiculoViagem.fimViagem)}</span> : null}

                </div>
            </div>

            <DataTable value={veiculoViagem.destinos} header="Destinos" paginator rows={5} style={{ marginTop: 20 }} emptyMessage="Nenhum destino registrado para esta viagem.">
                <Column field="dataHora" header="Data/hora" body={(rowData) => converterDataHora(rowData.dataHora)} style={{ width: "150px" }}></Column>
                <Column field="observacao" header="Observação"></Column>
            </DataTable>

            <label style={styles.labelPercurso}>Percurso: </label>

            {(veiculoViagem.pontosPercurso && veiculoViagem.pontosPercurso.length > 0) || (veiculoViagem.destinos && veiculoViagem.destinos.length > 0) ? <MapaPercursoVeiculoViagem
                pontosPercurso={veiculoViagem.pontosPercurso}
                destinos={veiculoViagem.destinos}
                finalizada={veiculoViagem.status === "FINALIZADA"}
            /> : null}

        </BaseCadastro>
    )
}

const styles = {
    titulo: {
        fontSize: 20,
        fontWeight: 'bold'
    },
    itemCabecalho: {
        display: "flex",
        gap: 8
    },
    labelCabecalho: {
        fontSize: 16,
        color: "#717192"
    },
    fieldCabecalho: {
        fontSize: 16,
    },
    labelPercurso: {
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 20
    }

};
